<template>
    <div class="table_wrap" style="padding-top:0">
        <el-table :data="value" border
            :header-cell-style="{padding: 0,borderBottom: 'none',background: '#0C6FFF ',color: 'white'}">
            <el-table-column label="预计付款时间" prop="planPayDate" align="center">
                <div slot-scope="{ row }">
                    <span v-if="disabled">{{row.planPayDate}}</span>
                    <!-- <el-input v-else v-model="row.dszPrice" @change="handle"
                        placeholder="请选择预计付款时间"></el-input> -->
                    <el-date-picker v-else v-model="row.planPayDate"
                        value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
                    </el-date-picker>
                </div>
            </el-table-column>
            <el-table-column label="付款金额(元)" prop="price" align="center">
                <div slot-scope="{ row }">
                    <span>{{row.price}}</span>
                    <!-- <el-input v-else v-model="row.price" @change="handle" placeholder="请输入付款金额"> -->
                    <!-- </el-input> -->
                </div>
            </el-table-column>
            <el-table-column label="附件" prop="files" align="center">
                <div slot-scope="{ row }">
                    <FileUpload :disabled="disabled" v-model="row.files" isBtn></FileUpload>
                </div>
            </el-table-column>
            <el-table-column label="付款状态" prop="payStatus" align="center">
                <div slot-scope="{ row }">
                    <el-switch v-model="row.payStatus" :disabled="disabled" active-text="已支付"
                        :active-value="1" inactive-text="未支付" :inactive-value="0">
                    </el-switch>
                    <!-- <span v-if="">{{row.payStatus}}</span>
                    <el-input v-else v-model="row.payStatus" @change="handle" placeholder="请输入备注说明">
                    </el-input> -->
                </div>
            </el-table-column>
            <el-table-column label="说明" prop="notes" align="center">
                <div slot-scope="{ row }">
                    <span v-if="disabled">{{row.notes}}</span>
                    <el-input v-else v-model="row.notes" @change="handle" placeholder="请输入备注说明">
                    </el-input>
                </div>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
export default {
  name: "safePay",
  props: {
    // item: {
    //   type: Object,
    //   default: () => { }
    // },
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  model: {
    event: "change"
  },

  data() {
    return {
      list: [],
    }
  },
  methods: {
    handle() {
      this.$emit("change", this.value);
      this.$emit("on-change", this.value);
    }
  }
}

</script>
